<standard-button
  variant="secondary-link"
  class="w-100"
  styleClass="w-100 d-flex flex-column align-items-start gap-0 text-decoration-none justify-content-top me-1"
  (handleClick)="handleWorkspaceClicked(node())"
  (handleDoubleClick)="handleWorkspaceDoubleClicked(node())"
  (contextmenu)="handleContextMenu($event)"
  tabindex="-1"
>
  <standard-line-clamp
    styleClass="text-body"
    [class]="node().data.unopened ? 'fw-bold' : ''"
  >
    <span [class]="isArchived() ? 'archived' : ''">
      @if (node().data.offlineText) {
        {{ node().label + " " + node().data.endDate + node().data.offlineText }}
      } @else {
        {{ node().label + " " + node().data.endDate }}
      }
    </span>
  </standard-line-clamp>
  @if (node().data.subLabel) {
    <standard-line-clamp class="small d-block sublabel">
      {{ node().data.subLabel }}
      @if (node().data.archiveDeadline) {
        <span class="text-danger">{{ node().data.archiveDeadline }}</span>
      }
    </standard-line-clamp>
    @if (this.isOfflineWebMode && node().data.copiedAt) {
      <standard-line-clamp class="small d-block sublabel">
        <div class="bg-light p-2 rounded">
          {{ node().data.copiedAt }}
        </div>
      </standard-line-clamp>
    }
  }
</standard-button>

@if (node().data.role === EngagementRole.ExternalReviewer) {
  <div class="me-1 mt-auto mb-auto icon-holder">
    <standard-icon
      [icon]="faGlasses"
      [standardTooltip]="externalReviewerTooltipText"
    />
  </div>
}

@if (isInRemoteStorage()) {
  <div class="me-1 mt-auto mb-auto">
    <standard-button
      label="Restore"
      i18n-label
      variant="secondary-outline"
      styleClass="p-1 fw-bold"
      [disabled]="restoreDisabled()"
      (handleClick)="handleRestoreRemoteClicked(node())"
      [standardTooltip]="restoreTooltip()"
      [showTooltipWhenDisabled]="true"
    />
  </div>
}

@if (node().data.purpose === EngagementPurposeType.Training) {
  <div class="me-1 mt-auto mb-auto" icon-holder>
    <standard-icon
      [icon]="faGraduationCap"
      [standardTooltip]="trainingTooltipText"
    />
  </div>
}

@if (isArchived()) {
  <div class="me-1 mt-auto mb-auto icon-holder">
    <standard-icon
      [icon]="faBriefcase"
      [standardTooltip]="archiveTooltipText"
    />
  </div>
}

@if (state() === EngagementState.Locked) {
  <div class="me-1 mt-auto mb-auto icon-holder">
    <standard-icon
      [icon]="faLock"
      [standardTooltip]="node().data.lockedTooltip"
    />
  </div>
}

<div class="mt-auto mb-auto me-2 actions-holder">
  <standard-button-dropdown-actions
    #dropdownMenu
    styleClass="btn-actions"
    [dropdownIcon]="faEllipsisV"
    [context]="node()"
    [items]="contextMenuItems()"
    [loading]="contextMenuLoading()"
    (mouseover)="handleMenuHover(node(), dropdownMenu)"
    (focus)="handleMenuHover(node(), dropdownMenu)"
    (onToggle)="handleMenuToggled(node(), dropdownMenu, $event)"
    tabindex="0"
  />
</div>
